import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { IIncidenceResolution } from 'modules/sales/incidence-resolution/interfaces';
import { SOLUTION_STATUS } from '../constants/solution-status.enum';
import { IChargesToResponsible } from 'modules/sales/incidence/interfaces/ISolution';

class IncidenceResolutionService extends EntityApiService<IIncidenceResolution> {
  updateStatus = (id: string, status: SOLUTION_STATUS) => {
    return ApiClientService.patch(this.getPath(`/${id}/status`), {
      status,
    });
  };

  updateResponsible = (id: string, params: Partial<IChargesToResponsible>): any => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${id}/responsible`), params));
  };
}

export default new IncidenceResolutionService('/ms-sales/api/incidence-resolution');
